import { lazy } from "react";

// Rutas privadas (protegidas por PrivateRoute)
const Inicio = lazy(() => import("../paginas/Dashboard"));
const Usuarios = lazy(() => import("../paginas/Usuarios"));
const Productos = lazy(() => import("../paginas/Productos"));
const Mantenciones = lazy(() => import("../paginas/Mantenciones"));
const ConfiguracionEstilos = lazy(() => import("../paginas/ConfiguracionEstilos"));
const Reparaciones = lazy(() => import("../paginas/Reparaciones"))
// Rutas públicas
const Login = lazy(() => import("../paginas/Login"));
const NoAutorizado = lazy(() => import("../paginas/NoAutorizadoPage"));

// Rutas privadas
export const privateRoutes = [
    { path: "/inicio", component: Inicio },
    { path: "/usuarios", component: Usuarios },
    { path: "/productos", component: Productos },
    { path: "/mantenciones", component: Mantenciones },
    { path: "/configuracion", component: ConfiguracionEstilos },
    { path: "/reparaciones", component: Reparaciones },
];

// Rutas públicas
export const publicRoutes = [
    { path: "/", element: <Login /> },
    { path: "/no-autorizado", element: <NoAutorizado /> },
];
